import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function customEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/;

    const value = control.value;

    if (!value) {
      return null;
    }
    const isValid = emailPattern.test(value);

    return !isValid ? {email: true} : null;
  };
}
